import React, { useState } from 'react';
import infoIcon from '../../../../../assets/infoG.svg';

interface KeywordSlideProps {
  onAddKeyword: (keyword: string) => void;
  onRemoveKeyword: (index: number) => void;
  keywords: string[];
}

const KeywordSlide: React.FC<KeywordSlideProps> = ({
  onAddKeyword,
  onRemoveKeyword,
  keywords
}) => {
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleAddKeyword = () => {
    const trimmedKeyword = inputValue.trim();
    if (trimmedKeyword) {
      if (keywords.some(k => k.toLowerCase() === trimmedKeyword.toLowerCase())) {
        setErrorMessage('This keyword already exists');
        return;
      }
      setErrorMessage('');
      onAddKeyword(trimmedKeyword);
      setInputValue('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleAddKeyword();
    }
  };

  return (
    <div className="flex flex-col gap-6">
      {/* Info Banner */}
      <div className="flex flex-col w-full bg-[#388E3C] rounded-[9px] pl-[9px] py-[1px] pr-[1px]">
        <div className="flex items-center text-left gap-2 bg-[#FFFFFF] rounded-r-[8px] px-[4px] py-[4px]">
          <img src={infoIcon} alt="info" className="w-[12px] h-[12px] mr-[4px] text-[#388E3C]" />
          <p className="text-[12px] font-medium text-[#388E3C]">
            Keywords help identify leads by matching what you're looking for.
          </p>
        </div>
      </div>

      {/* Input Section */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              setErrorMessage('');
            }}
            onKeyPress={handleKeyPress}
            placeholder="Add keywords here"
            className="flex p-[16px] h-[34px] w-full border text-[14px] font-normal border-[#DDDDDD] rounded-[10px] focus:outline-none focus:ring-1 focus:ring-[#42E56F] text-[#222222] placeholder-[#9FA1A7] placeholder:text-[14px] placeholder:font-normal"
          />
          <button
            onClick={handleAddKeyword}
            disabled={!inputValue.trim()}
            className={`h-[34px] whitespace-nowrap px-3 rounded-[8px] font-normal ${
              inputValue.trim() 
                ? 'bg-[#29DC5B] text-[#222222] hover:bg-[#0FAA3A]' 
                : 'bg-[#FAFAFA] text-[#222222] cursor-not-allowed'
            }`}
          >
            + Add keyword
          </button>
        </div>
        {errorMessage && (
          <p className="text-[12px] text-[#DC2626] text-left mt-[2px] ml-1">{errorMessage}</p>
        )}
      </div>

      {/* Keywords List */}
      <div className="mt-[14px] rounded-[10px] bg-[#F7F7F7] p-[16px] min-h-[108px] max-h-[280px] w-full">
        <p className="text-[12px] font-medium text-[#000000] mb-2 text-left">
          Keywords
        </p>
        <div className="flex flex-wrap gap-2 overflow-y-auto max-h-[210px] scrollbar-hide">
          {keywords.map((keyword, index) => (
            <div
              key={index}
              className={`px-3 py-1 rounded-[8px] text-[14px] flex items-center gap-2 max-w-full break-words
                ${index % 3 === 0 ? 'bg-[#E5F9FF] text-[#0891B2]' : 
                  index % 3 === 1 ? 'bg-[#E5FFE6] text-[#16A34A]' : 
                  'bg-[#FFE5E5] text-[#DC2626]'}`}
            >
              <span className="truncate">{keyword}</span>
              <button
                onClick={() => onRemoveKeyword(index)}
                className="text-current hover:text-opacity-70 flex-shrink-0"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeywordSlide; 